import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const TrimsDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="Trims Section"
      sectionId="trims"
      sectionKey="Trims"
      description="Trims Inventory & Management"
      backRoute="/"
    />
  );
};

export default TrimsDashboard;
